/**
 * Get the appropriate padding-left class based on sidebar collapsed state
 * @param {boolean} isCollapsed - Whether the sidebar is collapsed
 * @returns {string} Tailwind padding class
 */
export const getSidebarPadding = (isCollapsed) => {
  return isCollapsed ? 'md:pl-16' : 'md:pl-64';
};

/**
 * Get the appropriate margin-left class based on sidebar collapsed state  
 * @param {boolean} isCollapsed - Whether the sidebar is collapsed
 * @returns {string} Tailwind margin class
 */
export const getSidebarMargin = (isCollapsed) => {
  return isCollapsed ? 'md:ml-16' : 'md:ml-64';
};